import {
  GET_ALL_BOOKINGS_REQUEST,
  GET_ALL_BOOKINGS_SUCCESS,
  GET_ALL_BOOKINGS_FAILURE,
  GET_ALL_BOOKINGS_CLEAR,
  GetAllBookingsActionTypes,
  GetAllBookingsState
} from "store/reducers/lodgingRequest/get-all-bookings/types";

const defaultState: GetAllBookingsState = {
  isLoading: false,
  errorMessage: ""
};

export default function getAllBookings(state = defaultState, action: GetAllBookingsActionTypes): GetAllBookingsState {
  switch (action.type) {
    case GET_ALL_BOOKINGS_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case GET_ALL_BOOKINGS_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case GET_ALL_BOOKINGS_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    case GET_ALL_BOOKINGS_CLEAR:
      return {
        ...state,
        isLoading: false,
        errorMessage: "",
        contents: []
      };
    default:
      return state;
  }
};